module.exports = __webpack_public_path__ + "static/img/carousel_1.ff81162c.jpg";